import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomePageComponent } from './Modules/Home/Components/home-page/home-page.component';
import { RankedChoiceVoteingSmsComponent } from './Modules/Home/Components/ranked-choice-voteing-sms/ranked-choice-voteing-sms.component';
import { LoginPageComponent } from './Modules/Oauth/Components/login-page/login-page.component';
import { SubAccountComponent } from './Modules/Oauth/Components/sub-account/sub-account.component';
import { CustomerOnboardingComponent } from './Modules/Onboard/Components/customer-onboarding/customer-onboarding.component';
import { OnboardingFormComponent } from './Modules/Onboard/Components/onboarding-form/onboarding-form.component';
import { OnboardingStatusComponent } from './Modules/Onboard/Components/onboarding-status/onboarding-status.component';

const routes: Routes = [
  {path:'',redirectTo:'login', pathMatch: 'full' },
  { path: 'login',
    loadChildren: () => import('../app/Modules/Oauth/oauth.module').then(m => m.OauthModule)
  },
  // { path: 'login', component: LoginPageComponent},
  
  // { path: 'home', component: HomePageComponent}
  {
    path: 'home',
    loadChildren: () => import('../app/Modules/Home/home.module').then(m => m.HomeModule)
  },
  { path: 'vote/:pollId', component:RankedChoiceVoteingSmsComponent},
  { path: 'self-registration', component:SubAccountComponent},
  { path: 'customer-onboarding', component:CustomerOnboardingComponent},
  { path: 'onboarding/form', component: OnboardingFormComponent },
  { path: 'onboarding/status', component: OnboardingStatusComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
